<template>
  <div v-if="$store.getters.currentItemVariation && $store.getters.currentItemVariation.item && $store.getters.currentItemVariation.item.free5" class="container-max">
    <div class="responsive-iframe--video">
      <iframe
          :src="'https://www.youtube.com/embed/' + $store.getters.currentItemVariation.item.free5"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
      >
      </iframe>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
